var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-form-item",
      class: {
        "is-error": _vm.hasError,
        "app-row-input-no-error-space": _vm.noErrorSpace
      }
    },
    [
      _c("div", { staticClass: "el-form-item__content" }, [
        _c(
          "div",
          { staticClass: "app-row-input__input" },
          [
            _vm.computedType
              ? _c("app-input", {
                  ref: "input",
                  attrs: {
                    slot: "reference",
                    type: _vm.computedType,
                    placeholder: _vm.computedPlaceholder,
                    options: _vm.computedOptions,
                    readonly: _vm.readonly,
                    disabled: _vm.disabled
                  },
                  on: { "app-event": _vm.onAppEvent },
                  slot: "reference",
                  model: {
                    value: _vm.model,
                    callback: function($$v) {
                      _vm.model = $$v
                    },
                    expression: "model"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errorMessage,
                expression: "errorMessage"
              }
            ],
            staticClass: "el-form-item__error"
          },
          [_vm._v(_vm._s(_vm.errorMessage))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b94563ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b94563ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/parts/AppRowInput.vue
// module id = null
// module chunks = 